import React, { useEffect, useState, useRef } from "react";

// Import Bootstrap
import { Dropdown, Modal, Offcanvas } from "react-bootstrap";
import GoogleComponent from '../pages/auth/Clientlogin/Google';

// Import Images
import logoWhiteImage from "../assets/images/logo-white.svg";
import userImage1 from "../assets/images/user-img-1.png";
import authImg1 from "../assets/images/auth-img-1.jpg";
import laptopDesktopImg from "../assets/images/auth-laptop-desktop-img-1.png";
import laptopDesktopBgImg from "../assets/images/auth-laptop-desktop-img-bg.png";

// Import Icons
import bellIcon from "../assets/images/icons/bell-white-icon.svg";
import crossIcon from '../assets/images/icons/cross-gray-icon.svg'
import eyeViewIcon from "../assets/images/icons/eye-view-icon.svg";
import eyeHideIcon from "../assets/images/icons/eye-hide-icon.svg";
import unstopableIcon from "../assets/images/icons/unstopable-icon.svg";
import twitterIcon from "../assets/images/icons/twitter-icon.svg";
import googleIcon from "../assets/images/icons/google-icon.svg";
import microsoftIcon from "../assets/images/icons/microsoft-icon.svg";
import linkedinIcon from "../assets/images/icons/linkedin-icon.svg";

import walletIcon from "../assets/images/icons/wallet-gray-icon.svg";
import otcIcon from "../assets/images/icons/ot-trade-icon.svg";
import transactionIcon from "../assets/images/icons/transaction-in-arrow.svg";
import { Link } from "react-router-dom";

function Header() {
    const [forgetPasswordStep, setForgetPasswordStep] = useState(1);

    const [signupShow, setSignupShow] = useState(false);
    const [loginShow, setLoginShow] = useState(false);

    const [loginOffcanvas, setLoginOffcanvas] = useState(false);
    const [signupOffcanvas, setSignupOffcanvas] = useState(false);
    const [forgotOffcanvas, setForgotOffcanvas] = useState(false);

    // User Signup
    const handleSignupClose = () => {
        setSignupShow(false);
    }
    const handleSignupShow = () => {
        setSignupShow(true);
        setLoginShow(false);
    }

    // User Login
    const handleLoginClose = () => {
        setLoginShow(false);
    }
    const handleLoginShow = () => {
        setLoginShow(true);
        setSignupShow(false);
    }


    // Show/Hide Password

    const [passwordsVisibility, setPasswordsVisibility] = useState({
        userPassword: false,
        confirmPassword: false,
    });
    const togglePasswordVisibility = (field) => {
        setPasswordsVisibility((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };


    // User Signup Offcanvas
    const onSignupOffcanvasClose = () => {
        setSignupOffcanvas(false)
    }
    const onSignupOffcanvasShow = () => {
        setSignupOffcanvas(true);
        setLoginOffcanvas(false);
    }


    // User Login Offcanvas
    const onLoginOffcanvasClose = () => {
        setLoginOffcanvas(false)
    }
    const onLoginOffcanvasShow = () => {
        setLoginOffcanvas(true);
        setSignupOffcanvas(false);
    }


    // User Login Offcanvas
    const onForgotOffcanvasClose = () => {
        setForgotOffcanvas(false)
    }
    const onForgotOffcanvasShow = () => {
        setForgotOffcanvas(true);
        setLoginOffcanvas(false);
    }


    // Otp Code
    const [otp, setOtp] = useState("");
    const handleOtpChange = (e) => {
        const value = e.target.value.replace(/\D/g, ""); // Allow only digits
        if (value.length <= 4) {
            setOtp(value);
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("Text").replace(/\D/g, ""); // Extract digits from pasted data
        if (pasteData.length == 4) {
            setOtp(pasteData);
        }
    };


    const logout = () => {
        sessionStorage.removeItem('logedinUser');
    }

    const sessionvalue = JSON.parse(sessionStorage.getItem("logedinUser"));
    return (
        <>
            <header>
                <div className="header-desktop">
                    <div className="container">
                        <div className="row">
                            <div className="col-4 align-self-center">
                                <div className="logo-wrapper">
                                    <a href="/" className="logo">
                                        <img src={logoWhiteImage} alt="logo" />
                                    </a>
                                </div>
                            </div>
                            <div className="col-8 align-self-center">
                                <ul className="features">
                                    <li className="notification-dropdown">

                                        <Dropdown>
                                            <Dropdown.Toggle>
                                                <a href="#" className="bel-wrapper"><img src={bellIcon} alt="icon" /></a>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item href="#">
                                                    <div className="notification-wrapper">
                                                        <div className="notification-header">
                                                            <h3>Notifications (23)</h3>
                                                            <a href="#" className="cross-icon"><img src={crossIcon} alt="icon" /></a>
                                                        </div>
                                                        <div className="notification-body">
                                                            <ul className="notification-list">
                                                                <li>
                                                                    <div className="notification-card">
                                                                        <div className="content">
                                                                            <h3>Congratulations! 🎉</h3>
                                                                            <p>Your application to become a Talent on OtterTrip has been approved. Travellers can now view your profile and connect with you.</p>
                                                                            <span className="date">23 July 2024 at 20:35</span>
                                                                        </div>
                                                                        <div className="icon">
                                                                            <span className="status"></span>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div className="notification-card">
                                                                        <div className="content">
                                                                            <h3>New Tour Added! 🌍</h3>
                                                                            <p>Exciting news! A new tour has been added to OtterSelect. Tap to explore the details and book your adventure!</p>
                                                                            <span className="date">23 July 2024 at 20:35</span>
                                                                        </div>
                                                                        <div className="icon">
                                                                            <span className="status"></span>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        {/*<div className="notification-footer">
                                                        <a href="#">View all notifications</a>
                                                    </div>*/}
                                                    </div>
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </li>
                                    {sessionvalue &&
                                        <>
                                            <li>
                                                < div className="dropdown-v1">
                                                    <Dropdown>
                                                        <Dropdown.Toggle>
                                                            <p>{sessionvalue.username}</p>
                                                            <img width="50px" height="50px" src={sessionvalue.picture} alt="img" />
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {/* <Dropdown.Item href="#">My Bookings</Dropdown.Item>
                                                            <Dropdown.Item href="#">Wishlist</Dropdown.Item>
                                                            <Dropdown.Item href="#">Join as Talent</Dropdown.Item>
                                                            <Dropdown.Item href="#">Settings</Dropdown.Item> */}
                                                            <Dropdown.Item href="/" onClick={logout}>Log out</Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </li>

                                        </>
                                    }
                                    {!sessionvalue &&
                                        <li>
                                            <a href="#" className="btn-style transparent white-border" onClick={onLoginOffcanvasShow}>Login</a>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {sessionvalue &&
                    <div className="header-mobile">
                        <ul className="mobile-menu">
                            <li>
                                <Link to="/" className="active">
                                    <span className="icon">
                                        <img src={walletIcon} alt="icon" />
                                    </span>
                                    <p className="f-12">Assets</p>
                                </Link>
                            </li>
                            <li>
                                <Link to="/otc-trade">
                                    <span className="icon">
                                        <img src={otcIcon} alt="icon" />
                                    </span>
                                    <p className="f-12">OTC Trade</p>
                                </Link>
                            </li>
                            <li>
                                <Link to="/transaction-history">
                                    <span className="icon">
                                        <img src={transactionIcon} alt="icon" />
                                    </span>
                                    <p className="f-12">Transaction History</p>
                                </Link>
                            </li>
                            <li>
                                <Link to="/login">
                                    <span className="icon">
                                        <img src={userImage1} className="user-img" alt="icon" />
                                    </span>
                                    <p className="f-12">Profile</p>
                                </Link>
                            </li>
                        </ul>
                    </div>
                }
            </header >

            {/* Signup Modal Start */}
            < Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal user-auth-modal" show={signupShow} onHide={handleSignupClose} >
                <Modal.Body>
                    <div className="user-auth-wrapper">
                        <div className="row row-eq-height">
                            <div className="col-md-6 align-self-center">
                                <div className="form-wrapper">
                                    <h2 className="h2">Get Started</h2>
                                    <p>Already have an account? <a href="#" onClick={handleLoginShow}>Log in</a></p>
                                    <div className="form auth-form">
                                        <div className="form-group checkbox-group flex mb-16">
                                            <input type="checkbox" id="terms-condition" />
                                            <label className="small" htmlFor="terms-condition">Accept Terms and Conditions, Privacy Policy and Cancellation Policy.</label>
                                        </div>
                                        <div className="form-group submit">
                                            <a href="#" className="btn-style full dark">Sign Up</a>
                                        </div>
                                    </div>
                                    <div className="social-wrapper">
                                        <p className="or-line"><span>OR</span></p>
                                        <ul className="social-login">
                                            <li><a href="#"><img src={unstopableIcon} alt="icon" /></a></li>
                                            <li><a href="#"><img src={twitterIcon} alt="icon" /></a></li>
                                            <li><a href="#"><img src={googleIcon} alt="icon" /></a></li>
                                            <li><a href="#"><img src={linkedinIcon} alt="icon" /></a></li>
                                        </ul>
                                    </div>
                                    <div className="auth-footer">
                                        <div className="row">
                                            <div className="col-md-6 align-self-center">
                                                <a href="#" className="auth-logo"><img src={logoWhiteImage} alt="logo" /></a>
                                            </div>
                                            <div className="col-md-6 align-self-center">
                                                <p className="copyright small">© 2025 DORU.CO</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 align-self-center">
                                <div className="auth-right-img">
                                    <img src={authImg1} alt="img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
            {/* Signup Modal End */}

            {/* Login Modal Start */}
            <Modal size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered className="modal user-auth-modal" show={loginShow} onHide={handleLoginClose}>
                <Modal.Body>
                    <div className="user-auth-wrapper">
                        <div className="row row-eq-height">
                            <div className="col-md-6 align-self-center">
                                <div className="form-wrapper">
                                    <h2 className="h2">Welcome Back</h2>
                                    <p>Don’t have an account? <a href="#" onClick={handleSignupShow}>Sign Up</a></p>
                                    <div className="form auth-form">
                                        <div className="form-group submit">
                                            <a href="#" className="btn-style full dark" onClick={(e) => {
                                                e.preventDefault();
                                                setLoginShow(false);
                                            }}>Log In</a>
                                        </div>
                                    </div>
                                    <div className="social-wrapper">
                                        <p className="or-line"><span>OR</span></p>
                                        <ul className="social-login">
                                            <li><a href="#"><img src={unstopableIcon} alt="icon" /></a></li>
                                            <li><a href="#"><img src={twitterIcon} alt="icon" /></a></li>
                                            <li><a href="#"><img src={googleIcon} alt="icon" /></a></li>
                                            <li><a href="#"><img src={linkedinIcon} alt="icon" /></a></li>
                                        </ul>
                                    </div>
                                    <div className="auth-footer">
                                        <div className="row">
                                            <div className="col-md-6 align-self-center">
                                                <a href="#" className="auth-logo"><img src={logoWhiteImage} alt="logo" /></a>
                                            </div>
                                            <div className="col-md-6 align-self-center">
                                                <p className="copyright small">© 2025 DORU.CO</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 align-self-center">
                                <div className="auth-right-img">
                                    <img src={authImg1} alt="img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Login Modal End */}


            {/* Signup Offcanvas Start */}
            <Offcanvas show={signupOffcanvas} className="user-auth-offcanvas" onHide={onSignupOffcanvasClose} placement={'end'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="user-auth-wrapper-main">
                        <div className="auth-laptop-img">
                            <img src={laptopDesktopImg} alt="img" />
                        </div>
                        <div className="user-auth-wrapper">
                            <div className="form-wrapper">
                                <h3 className="f-40 w-500 h-font">Sign up</h3>
                                <ul className="social-auth">
                                    <li><a href="#" className="btn-style icon transparent"><img src={googleIcon} alt="icon" />Sign in with Google</a></li>
                                    {/* <li><a href="#" className="btn-style icon transparent"><img src={microsoftIcon} alt="icon" />Sign in with Microsoft</a></li> */}
                                </ul>
                                <div className="form auth-form">
                                    <div className="form-group submit">
                                        <a href="#" className="btn-style full dark" onClick={(e) => {
                                            e.preventDefault();
                                            setLoginShow(false);
                                        }}>Create Account</a>
                                        <div className="no-account">
                                            <p className="p w-600">Already have an account? <a href="#" className="f-16 w-600" onClick={onLoginOffcanvasShow}>Login</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Signup Offcanvas End */}

            {/* Login Offcanvas Start */}
            <Offcanvas show={loginOffcanvas} className="user-auth-offcanvas" onHide={onLoginOffcanvasClose} placement={'end'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="user-auth-wrapper-main">
                        <div className="auth-laptop-img">
                            <img src={laptopDesktopImg} alt="img" />
                        </div>
                        <div className="user-auth-wrapper">
                            <div className="form-wrapper">
                                <h3 className="f-40 w-500 h-font">Login</h3>
                                <ul className="social-auth">

                                    <GoogleComponent googleImage={googleIcon} />
                                    {/* <li><a href="#" className="btn-style icon transparent"><img src={microsoftIcon} alt="icon" />Sign in with Microsoft</a></li> */}
                                </ul>
                                {/* <div className="form auth-form">
                                    <div className="form-group submit">
                                        <a href="#" className="btn-style full dark" onClick={(e) => {
                                            e.preventDefault();
                                            setLoginShow(false);
                                        }}>Log In</a>
                                        <div className="no-account">
                                            <p className="p w-600">Don’t have an account? <a href="#" className="f-16 w-600" onClick={onSignupOffcanvasShow}>Sign Up</a></p>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Login Offcanvas End */}

            {/* Forgot Offcanvas Start */}
            <Offcanvas show={forgotOffcanvas} className="user-auth-offcanvas" onHide={onForgotOffcanvasClose} placement={'end'}>
                <Offcanvas.Header closeButton>
                    {/*<Offcanvas.Title>Offcanvas</Offcanvas.Title>*/}
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="user-auth-wrapper-main">
                        <div className="auth-laptop-img">
                            <img src={laptopDesktopImg} alt="img" />
                        </div>
                        <div className="user-auth-wrapper">
                            <div className="form-wrapper">
                                <h3 className="f-40 w-500 h-font">Forgot Password</h3>
                                <div className="form auth-form">
                                    {(forgetPasswordStep == 1) &&
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="user-email">Email ID</label>
                                                <input type="text" id="user-email" className="form-control" placeholder="Enter Email" />
                                            </div>
                                            <div className="form-group submit">
                                                <a href="#" className="btn-style full dark" onClick={() => setForgetPasswordStep(2)}>Continue</a>
                                            </div>
                                        </div>
                                    }

                                    {(forgetPasswordStep == 2) &&
                                        <div>
                                            <div className="form-group">
                                                <p className="p w-600 otp-text">Enter OTP sent to mail id abc@ayx.com</p>
                                                <div className="row">
                                                    <div className="col-6 align-self-center">
                                                        <label htmlFor="email-otp">Enter OTP</label>
                                                    </div>
                                                    <div className="col-6 align-self-center">
                                                        <div className="resend-otp">
                                                            <label htmlFor="resend-otp">Resend OTP</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <input
                                                    type="text"
                                                    id="email-otp"
                                                    className="form-control otp-input"
                                                    placeholder="----"
                                                    value={otp}
                                                    onChange={handleOtpChange}
                                                    onPaste={handleOtpPaste}
                                                    maxLength="4" // Optional for better UX
                                                />
                                            </div>
                                            <div className="form-group submit">
                                                <a href="#" className="btn-style full dark" onClick={() => setForgetPasswordStep(3)}>Continue</a>
                                            </div>
                                        </div>
                                    }

                                    {(forgetPasswordStep == 3) &&
                                        <div>
                                            <div className="form-group">
                                                <label htmlFor="forgot-password">Enter New Password</label>
                                                <div className="key-input">
                                                    <input
                                                        type={passwordsVisibility.userPassword ? "text" : "password"}
                                                        id="forgot-password"
                                                        className="form-control"
                                                        placeholder="Enter Password"
                                                    />
                                                    <img
                                                        src={passwordsVisibility.userPassword ? eyeHideIcon : eyeViewIcon}
                                                        className="icon"
                                                        alt="toggle visibility"
                                                        onClick={() => togglePasswordVisibility('userPassword')}
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="forgot-repeat-password">Reenter New Password</label>
                                                <div className="key-input">
                                                    <input
                                                        type={passwordsVisibility.confirmPassword ? "text" : "password"}
                                                        id="forgot-repeat-password"
                                                        className="form-control"
                                                        placeholder="Enter Password"
                                                    />
                                                    <img
                                                        src={passwordsVisibility.confirmPassword ? eyeHideIcon : eyeViewIcon}
                                                        className="icon"
                                                        alt="toggle visibility"
                                                        onClick={() => togglePasswordVisibility('confirmPassword')}
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group submit">
                                                <a href="#" className="btn-style full dark" onClick={onForgotOffcanvasClose}>Continue</a>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {/* Forgot Offcanvas End */}
        </>
    )
}

export default Header
